const TYPES = `HIMALAYAS_SIMULATION`;
export const START_SPICE_CARD_RUN = `${TYPES}/start_spice_card_run`;
export const UPDATE_SIMULATION_INFO = `${TYPES}/update_simulation_info`;
export const START_NEW_WORKFLOW = `${TYPES}/start_new_workflow`;
export const INIT_SIMULATION_INFO = `${TYPES}/init_simulation_info`;
export const GET_WORKFLOW_MONITOR = `${TYPES}/get_workflow_monitor`;
export const CANCEL_WORKFLOW = `${TYPES}/cancel_workflow`;
export const GET_SIMULATION_LOG = `${TYPES}/get_simulation_log`;
export const START_IO_SIM_RUN = `${TYPES}/start_io_sim_run`;
export const GET_VERIFICATION_WORKFLOW = `${TYPES}/get_verification_workflow`;